import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { AppBar, Toolbar, Box, Grid, Typography, Link, Button, Container } from '@mui/material';
import Home from "./core/Home";
import Menu from "./core/Menu";
import Signup from "./user/Signup";
import SignupPending from "./user/SignupPending";
import Signin from "./user/Signin";
import PublicHome from "./core/PublicHome";
import PublicMemberLogos from "./core/PublicMemberLogos";
import Profile from "./user/Profile";
import Users from "./user/Users";
import EditProfile from "./user/EditProfile";
import Proposals from "./event/proposals";
import ConferencePresentationSubmission from "./event/ConferencePresentationSubmission.js";
import FindPeople from "./user/FindPeople";
import NewPost from "./post/NewPost";
import NewForumPost from "./forum/NewForumPost";
import EditForumPost from "./forum/EditForumPost"
import SingleForumPost from "./forum/SingleForumPost"
import EditPost from "./post/EditPost";
import SinglePost from "./post/SinglePost";
import PrivateRoute from "./auth/PrivateRoute";
import ForgotPassword from "./user/ForgotPassword";
import ResetPassword from "./user/ResetPassword";
import ForceChangePassword from "./user/ForceChangePassword";
import Admin from "./admin/Admin";
import AdminGroup from "./admin/AdminGroup";

import GroupAccess from "./group/GroupAccess";
import groupList from "./group/GroupList";
import SingleGroup from "./group/SingleGroup";

import CreateFile from "./file/CreateFile";
import CreateEvent from "./event/CreateEvent";
import AllEvents from "./event/AllEvents";
import SingleEvent from "./event/singleEvent";
import ShowCaseEvent from "./event/ShowCaseEvent";
import Presentation from "./event/Presentation";

import PublicAbout from "./core/PublicAbout";
import Charter from "./core/Charter";
import PublicEvents from "./core/PublicEvents";
import PolicyStatement from './core/PolicyStatement';

import Survey from "./core/Survey";
import Survey2022 from "./core/Survey2022";
import ContentSurvey2022 from "./core/ContentSurvey2022";
import Members from "./core/Members";

import Sping2021eventRegReport from './event/EventRegReport';
import publicNashvilleClosed from './core/publicNashvilleClosed';
import publicVirtual23 from './core/publicVirtual23';
import Registration25 from './event/2025Registration.js'
//import publicCallforPapers from './core/callforPapers';

// import nashvilleSponsorReg from './event/nashvilleSponsorReg';
import publiceventKC_original from './core/publiceventKC_original'
import kansasCityEvent from './event/kansasClosed';
import publicKansasCityEvent from './core/publicKansasClosed';
import publicMesaEventDetailed from './core/publicMesas25details';

import OurSponsors from './core/OurSponsors';
import SponsorOpportunity from './core/SponsorOpportunity';
import publiceventsping2022 from './core/publiceventsping2022';
// import PublicFall2021Event from './core/PublicFall2021Event';
import PublicSpringEvent2022 from './core/PublicSpringEvent2022';
import publicNashvillePhotos from './core/publicNashvillePhotos';

import Awards from './core/Awards';
import MerchDetail from './user/merchdetail';
import MerchCheckOut from './user/merchCheckOut';

import Fall2022Schedule from './event/event2022schedule';

import FallSponsorRegistration from './event/FallSponsorRegistration';
import eventFallVirtual2023 from './event/eventFallVirtual2023';

import Podcast from './core/Podcast';

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { syncUserFromServer } from "./auth";

// import { LinkedInPopUp } from 'react-linkedin-login-oauth2';

// import SuperAdminHome from './superAdmin/superadminhome'

// import { signout, isAuthenticated } from './auth';

import Privacy from './core/PrivacyStatement';
import Terms from './core/TermsStatement';

import eventDemo from './event/EventDemo';
import publicColoradoEvent from './core/publicColoradoEvent'
import publicNewOrleans from './core/publicNewOrleans'
import SchedulePage2026 from './core/SchedulePage2026'
import ConferencePresentations from "./event/ConferencePresentations.js";
import CallForPresentations2027 from './core/callForPresentations2027';

import AwardsDigitalPage from './awards/pages/AwardsPage';
import VerifyPage from './awards/pages/VerifyPage';
import PastEvents from './core/PastEvents';

const MainRouter = () => {
  useEffect(() => {
    syncUserFromServer();
  }, []);

  return (
  <Elements stripe={loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)}>
    {/* <Elements stripe={loadStripe(process.env.STRIPE_SECRET)}> */}
    <div className="container">

      <AppBar
        position="static"
        elevation={0}
        sx={{
          bgcolor: 'background.paper',
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ py: 1.5, gap: 2 }}>
            {/* Left: Logo + brand */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
              <Link href="/usershome" underline="none" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Box
                  component="img"
                  src={process.env.PUBLIC_URL + '/logo192.png'}
                  alt="SDSIC"
                  sx={{
                    height: { xs: 80, sm: 120 },
                    width: 'auto',
                    display: 'block',
                  }}
                />
              </Link>

              <Box sx={{ minWidth: 0 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.1 }}>
                  SDSIC
                </Typography>

                <Typography
                  variant="h6"
                  color="text.secondary"
                  sx={{
                    lineHeight: 1.2,
                    whiteSpace: 'normal',      // allow wrapping
                    overflowWrap: 'anywhere',  // break long strings if needed
                    wordBreak: 'break-word',   // extra safety
                  }}
                >
                  Designing the Future of Power Today
                </Typography>
              </Box>
            </Box>

            {/* Right: Nav / CTA */}
            <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>

              <Button
                href="/About"
                variant="contained"
                size="small"
                sx={{
                  borderRadius: 999,
                  textTransform: 'none',
                  fontWeight: 700,
                  px: 2,
                }}
              >
                Learn more
              </Button>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <Menu />
      <Box sx={{ mb: 3 }} />
      <Switch>

        <PrivateRoute exact path="/usershome" component={Home} />
        <PrivateRoute exact path="/publicNashvillePhotos" component={publicNashvillePhotos} />

        <Route exact path="/" component={PublicHome} />
        <Route exact path="/memberLogos" component={PublicMemberLogos} />
        <Route exact path="/about" component={PublicAbout} />
        <PrivateRoute exact path="/proposals" component={Proposals} />
        <PrivateRoute exact path="/ConferencePresentationSubmission" component={ConferencePresentationSubmission} />

        <Route exact path="/past-events" component={PastEvents} />
        <Route exact path="/awards" component={Awards} />
        <PrivateRoute exact path="/awards/digital" component={AwardsDigitalPage} />
        <Route exact path="/awards/verify/:id" component={VerifyPage} />
        <Route exact path="/events" component={PublicEvents} />
        <Route exact path="/podcast" component={Podcast} />
        <PrivateRoute exact path="/charter" component={Charter} />

        {/* <Route exact path="/event2020" component={Public2020Event} /> */}

        {/* <Route exact path="/fall2021event" component={NewSpring2021Event} /> */}
        {/* <Route exact path="/spring2022event" component={Spring2022Event} /> */}

        <Route exact path="/publicNashvilleClosed" component={publicNashvilleClosed} />
        <Route exact path="/publicVirtual23" component={publicVirtual23} />
        {/* <Route exact path="/nashvilleSponsorReg" component={nashvilleSponsorReg} /> */}

        <Route exact path="/publicKansasCityEvent" component={publicKansasCityEvent} />
        <Route exact path="/publicColoradoEvent" component={publicColoradoEvent} />
        <Route exact path="/publicNewOrleans" component={publicNewOrleans} />
        <Route exact path="/schedule2026" component={SchedulePage2026} />
        <Route exact path="/publicMesa25detail" component={publicMesaEventDetailed} />

        <Route exact path="/ConferencePresentations" component={ConferencePresentations} />
        <Route exact path="/callForPresentations2027" component={CallForPresentations2027} />
        {/* <Route exact path="/publicCallforPapers" component={publicCallforPapers} /> */}
        <Route exact path="/publicCallforPapers" component={publicKansasCityEvent} />


        <Route exact path="/publiceventKC_original" component={publiceventKC_original} />
        <Route exact path="/publiceventsping2022" component={publiceventsping2022} />
        <Route exact path="/sponsors" component={OurSponsors} />
        <Route exact path="/sponsor" component={SponsorOpportunity} />

        <PrivateRoute exact path="/fallVirtual23" component={eventFallVirtual2023} />
        <PrivateRoute exact path="/SpringEvent2022Calendar" component={PublicSpringEvent2022} />
        <PrivateRoute exact path="/kansasCityEvent" component={kansasCityEvent} />
        <PrivateRoute exact path="/spring2021Regreport" component={Sping2021eventRegReport} />
        <PrivateRoute exact path="/survey" component={Survey} />
        <PrivateRoute exact path="/survey2022" component={Survey2022} />
        <PrivateRoute exact path="/contentsurvey2022" component={ContentSurvey2022} />
        <PrivateRoute exact path="/members" component={Members} />
        <PrivateRoute exact path="/admin" component={Admin} />

        <PrivateRoute exact path="/admin/committee/:groupId" component={AdminGroup} />

        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/reset-password/:resetPasswordToken" component={ResetPassword} />
        <Route exact path="/change-password" component={ForceChangePassword} />

        <PrivateRoute exact path="/group/requestaccess/:groupId" component={GroupAccess} />

        <PrivateRoute exact path="/post/create/:groupId" component={NewPost} />
        <PrivateRoute exact path="/forumpost/create/:groupId" component={NewForumPost} />
        <PrivateRoute exact path="/forumpost/edit/:forumpostId" component={EditForumPost} />

        <PrivateRoute exact path="/post/:postId" component={SinglePost} />
        <PrivateRoute exact path="/forumpost/:forumpostId" component={SingleForumPost} />

        {/* <Route exact path="/linkedin" component={LinkedInPopUp} />             */}

        <PrivateRoute
          exact
          path="/post/edit/:postId"
          component={EditPost}
        />
        <PrivateRoute exact path="/users" component={Users} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/signuppending" component={SignupPending} />
        <Route exact path="/signin" component={Signin} />

        <Route exact path="/privacystatement" component={Privacy} />
        <Route exact path="/policystatement" component={PolicyStatement} />
        <Route exact path="/termsstatement" component={Terms} />

        <PrivateRoute
          exact
          path="/user/edit/:userId"
          component={EditProfile}
        />
        <PrivateRoute exact path="/findpeople" component={FindPeople} />
        <PrivateRoute exact path="/user/:userId" component={Profile} />

        <PrivateRoute exact path="/grouplist" component={groupList} />
        <PrivateRoute exact path="/singlegroup/:groupId" component={SingleGroup} />

        <PrivateRoute exact path="/file/create/:groupId" component={CreateFile} />
        <PrivateRoute exact path="/event/create/:groupId" component={CreateEvent} />
        <PrivateRoute exact path="/allevents" component={AllEvents} />

        <PrivateRoute exact path="/singleEvent/:eventId" component={SingleEvent} />
        <PrivateRoute exact path="/showcaseEvent/:eventId" component={ShowCaseEvent} />

        <PrivateRoute exact path="/presentation/:presentationId" component={Presentation} />

        {/* <Route exact path="/linkedin" component={LinkedInPopUp} />      */}

        {/* <Route exact path="/superadmin" component={SuperAdminHome} />     */}

        <PrivateRoute exact path="/eventDemo" component={eventDemo} />

        {/* <PrivateRoute exact path="/eventsimulation" component={eventSim} />     */}

        {/* <PrivateRoute exact path="/fallregistration" component={FallRegistration} /> */}
        {/* <PrivateRoute exact path="/NashvilleRegistration" component={NashvilleRegistration} /> */}

        <PrivateRoute exact path="/registration25" component={Registration25} />
        {/* <PrivateRoute exact path="/presenterReg25" component={PresenterReg25} /> */}

        {/* <Route exact path="/sponsorreg25" component={SponsorReg25} /> */}

        <PrivateRoute exact path="/fall2022schedule" component={Fall2022Schedule} />

        <PrivateRoute exact path="/fallSponsorRegistration" component={FallSponsorRegistration} />


      </Switch>
    </div>
  </Elements>
  );
};

export default MainRouter;